import { render, staticRenderFns } from "./Salescontract.vue?vue&type=template&id=647fb055"
import script from "./Salescontract.vue?vue&type=script&lang=js"
export * from "./Salescontract.vue?vue&type=script&lang=js"
import style0 from "./Salescontract.vue?vue&type=style&index=0&id=647fb055&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports